import React from "react";
import './slider-fullscreen.scss';

export default class FSliderComponent extends React.Component {

    isSwiping;
    movingSide;
    isNewState;
    wrapperDOM;
    contentDOM;
    interval;

    constructor() {
        super();
        this.state = {
            src: null,
            animated: false,
        }
        this.pagination = [];
        this.component = React.createRef();
        this.activeMediaId = 0;
    }

    componentDidMount(){
        this.wrapperDOM = this.component.current.querySelector('.wrapperDOM');
        this.data = this.props.data;
        this.setState({
            active: 0,
            next: this.props.data.length - 1,
            prev: 1,
        });
        this.interval = setInterval(()=>{
            this.changeSlideAuto();
        }, 7000);
    }

    getMediaDOMList() {
        this.contentDOM = this.wrapperDOM.querySelectorAll('.slider-content > *');
    }

    setActiveDOM() {
        this.activeDOM = this.wrapperDOM.querySelectorAll('.filler')[this.activeMediaId];
    }
    
    setNeighbors() {
        this.setState({ 
            next: this.state.active === this.props.data.length - 1 ? 0 : this.state.active + 1,
            prev: this.state.active === 0 ? this.props.data.length - 1 : this.state.active - 1,
        });
    }
    
    changeSlideAuto(){
        const neededBlock = this.wrapperDOM.querySelectorAll('.filler')[this.state.active ? this.state.active : 0];
        neededBlock.classList.add('animated');
        this.changeSlide2(
            neededBlock,
            (this.state.active < this.props.data.length - 1 ? this.state.active : -1) + 1,
            (this.state.next < this.props.data.length - 1 ? this.state.next : -1) + 1,
            (this.state.prev < this.props.data.length - 1 ? this.state.prev : -1) + 1
        );
    }

    changeSlide(index){
        const neededBlock = this.wrapperDOM.querySelectorAll('.filler')[this.state.active];
        neededBlock.classList.add('animated');
        clearInterval(this.interval);
        this.changeSlide2(neededBlock, index);
    }


    changeSlide2(neededBlock, current, previous = null, next = null){
        let hookEnd;
        const hook = new Promise ((resolve, reject) => {
            hookEnd = resolve;
        })
        neededBlock.querySelector('.heading .title').ontransitionend = function(event) {
            neededBlock.classList.remove('animated');
            hookEnd();
        }
        hook.then(e => {
            if (previous !== null && next !== null) {
                this.setState({
                    active: current,
                    prev: previous,
                    next: next,
                });
            } else {
                this.setState({ active: current});
                this.interval = setInterval(()=>{
                    this.changeSlideAuto();
                }, 7000);
            }
        })
    }

    render(){
        return (
            <div className="slider-fs" ref={this.component}>

                <div className="images">
                    <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544260/hp2021/slider_2/Image.png" alt="#" className="background"/>
                    <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544141/hp2021/slider_2/decoration_1.svg" className="decoration_1" alt="#"/>
                    <div className="decoration_2"></div>
                    <div className="decoration_3"></div> 
                </div>
                
                <div className={`wrapperDOM slider-content ${this.isSwiping ? 'swiping' : ''} ${this.movingSide > 0 ? 'to-left' : ''} ${this.movingSide < 0 ? 'to-right' : ''} ${this.isNewState ? 'new-state' : ''}`}>
                    {this.props.data.map((value, i) =>
                        <div key={i} className={`filler ${this.state.animated ? 'animated': ''} ${this.state.active === i ? 'current' : this.state.next === i ? 'next' : this.state.prev === i ? 'previous' : ''}`}>
                                <div className="wrap">
                                    <div className="heading">{}
                                        <ul className={`pagination ${this.props.data.length <= 1 ? 'disabled' : ''}`}>
                                            {this.props.data.map((val, index) =>
                                                <li key={index} className={index === this.state.active ? 'active' : ''} onClick={() => this.changeSlide(index)}></li>
                                            )}
                                        </ul>
                                        <p className="extra-title--h3 title">{value.title}</p> 
                                    </div>

                                    <div className={`illustration illustration-${i}`}>
                                        {value.imgArr.map((v, ind) =>
                                            <div key={ind} className={`img-${ind}`}>
                                                <img src={v} alt="#" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}